import JwtDecode from 'jwt-decode'
import API_PATH from '@/constants/apiPath'

const state = {
    user: (() => {
        try {
            return JwtDecode(localStorage.token)
        } catch (e) {
            return null
        }
    })(),
    globalLoader: false,
    previousRoute: '/',
    subscription: false
}

const getters = {
    currentUser (state) {
        return state.user
    },
    isLoading (state) {
        return state.globalLoader
    },
    previousRoute (state) {
        return state.previousRoute
    }
}

const mutations = {
    setUser (state, token) {
        localStorage.token = token
        state.user = JwtDecode(token)
    },
    unsetUser (state) {
        state.user = null
    },
    setPreviousRoute (state, path) {
        state.previousRoute = path
    },
    setSubscription (state, payload) {
        state.subscription = payload
    }
}

const actions = {
    unsetUser ({ commit }, payload) {
        delete localStorage.token
        commit('unsetUser')
    },
    async checkSubscription ({ commit }) {
        try {
            const resp = await this.$axios.post(API_PATH.subscription.check)
            if (resp && resp.data && resp.data.active) {
                commit('setSubscription', resp.data.active)
            } else {
                commit('setSubscription', false)
            }
        } catch (err) {
            commit('setSubscription', false)
            console.log(err)
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
